//@flow
import React, { Component } from 'react';
import { type TooltipProps } from '../../../../utilities/types';
import DefaultModelRowTr from '../../../../modules/CrudTable/components/DefaultModelRowTr';
import { ModelListTh } from '../../../../components/ModelListStyles';
import { Default, Desktop } from '../../../../components/Responsive';
import { CustomInfoTooltip } from './PartnersStyles';
import {
  PROCESSING_VOLUME_TOOLTIP,
  TRANSACTION_FEES_TOOLTIP
} from '../reducer';
type Props = {
  ...$Exact<TooltipProps>
};

export default class TableHeader extends Component<Props> {
  tooltip = (tooltipName: string) => (
    <CustomInfoTooltip
      message={
        'The amounts below are estimates based on the exchange rate at the time of purchase. Click to view exact breakdowns / details'
      }
      activeTooltip={this.props.activeTooltip}
      showTooltip={this.props.showTooltip}
      tooltipName={tooltipName}
    />
  );
  render() {
    return (
      <DefaultModelRowTr>
        <ModelListTh>Partner</ModelListTh>
        <Default>
          <ModelListTh right> Merchants </ModelListTh>
        </Default>
        <ModelListTh right>
          <Desktop>{this.tooltip(PROCESSING_VOLUME_TOOLTIP)}</Desktop>
          Processing Vol.
        </ModelListTh>
        <Desktop>
          <ModelListTh right>
            <Desktop>{this.tooltip(TRANSACTION_FEES_TOOLTIP)}</Desktop>
            Trans. Fees
          </ModelListTh>
        </Desktop>
      </DefaultModelRowTr>
    );
  }
}
